"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class CopyText {
    constructor(selector = null) {
        this.selector = '.prepain-copy-text';
        this.elements = null;
        this.selector = selector ? selector : this.selector;
        this.elements = document.querySelectorAll(this.selector);
        if (this.elements) {
            this.init();
        }
    }
    init() {
        this.elements.forEach((element) => {
            element.addEventListener('click', this.copyText);
        });
    }
    copyText(event) {
        return __awaiter(this, void 0, void 0, function* () {
            // data-copy-text
            event.stopImmediatePropagation();
            event.preventDefault();
            const target = event.target;
            const dataCopyText = target.getAttribute('data-copy-text');
            if (dataCopyText) {
                // copy to clipboard
                try {
                    yield navigator.clipboard.writeText(dataCopyText);
                    console.log('Text copied to clipboard');
                    // change text to copied
                    setTimeout(() => {
                        target.querySelector('span').textContent = 'COPIADO';
                    }, 100);
                    // change text back to original
                    setTimeout(() => {
                        target.querySelector('span').textContent = 'COPIAR';
                    }, 2000);
                }
                catch (err) {
                    console.error('Failed to copy: ', err);
                }
            }
            else {
                console.error('No data-copy-text attribute found');
            }
        });
    }
}
exports.default = CopyText;
